import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {document} from 'ssr-window';
import TetherComponent from 'react-tether'; // eslint-disable-line node/no-extraneous-import
import DOMUtils from '@spothero/utils/dom';
import DatePickerCalendarWithRange from '@spothero/ui/date-picker-calendar-with-range';
import Button from '@spothero/ui/button';
import DateUtils from 'utils/date';
import AirportDateRangePickerInputs from './AirportDateRangePickerInputs';
import WithAirportDateRangePicker from './WithAirportDateRangePicker';

class AirportDateRangePickerDesktop extends Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        selectedStartDate: PropTypes.string,
        selectedEndDate: PropTypes.string,
        showCalendar: PropTypes.bool,
        adjustStartOrEnd: PropTypes.string,
        invalidStartDate: PropTypes.bool,
        invalidEndDate: PropTypes.bool,
        onStartInputFocus: PropTypes.func,
        onEndInputFocus: PropTypes.func,
        onDateChange: PropTypes.func,
        onCloseCalendar: PropTypes.func,
        onSubmit: PropTypes.func,
        tetherKey: PropTypes.string,
        weekdays: PropTypes.array,
        disableAfterDate: PropTypes.string,
    };

    constructor(props) {
        super(props);

        this._TETHER_CLASS = `AirportDateRangePicker-tether-${props.id}`;
    }

    componentDidUpdate(prevProps, prevState) {
        const {showCalendar} = this.props;
        const {showCalendar: prevShowCalendar} = prevProps;

        if (showCalendar !== prevShowCalendar) {
            if (showCalendar) {
                document.body.addEventListener('mousedown', this._onBodyClick);
                document.body.addEventListener('touchstart', this._onBodyClick);
            } else {
                this._removeBodyClickListener();
            }
        }
    }

    componentWillUnmount() {
        this._removeBodyClickListener();
    }

    _onBodyClick = evt => {
        const {id, onCloseCalendar} = this.props;

        if (
            !DOMUtils.parent(evt.target, `.AirportDateRangePicker-${id}`) &&
            !DOMUtils.parent(evt.target, `.${this._TETHER_CLASS}`)
        ) {
            onCloseCalendar();
        }
    };

    _onDateChange = ({
        selectedStartDate,
        selectedEndDate,
        nextAdjustedStartOrEnd,
    }) => {
        this.props.onDateChange({
            selectedStartDate,
            selectedEndDate,
            nextAdjustedStartOrEnd: null,
            nextShowCalendar: !(selectedStartDate && selectedEndDate),
        });
    };

    _removeBodyClickListener() {
        document.body.removeEventListener('mousedown', this._onBodyClick);
        document.body.removeEventListener('touchstart', this._onBodyClick);
    }

    render() {
        const {
            id,
            showCalendar,
            selectedStartDate,
            selectedEndDate,
            adjustStartOrEnd,
            invalidStartDate,
            invalidEndDate,
            onStartInputFocus,
            onEndInputFocus,
            onSubmit,
            tetherKey,
            weekdays,
            disableAfterDate,
        } = this.props;
        const classes = classNames(
            'AirportDateRangePicker',
            `AirportDateRangePicker-${id}`
        );
        const tetherClasses = classNames(
            'AirportDateRangePicker-tether',
            this._TETHER_CLASS
        );
        const arrowClasses = classNames(
            'AirportDateRangePicker-calendar-arrow',
            {
                'AirportDateRangePicker-calendar-arrow-start': !(
                    adjustStartOrEnd === 'end'
                ),
                'AirportDateRangePicker-calendar-arrow-end':
                    adjustStartOrEnd === 'end',
            }
        );

        return (
            <div className={classes}>
                <TetherComponent
                    key={tetherKey}
                    className={tetherClasses}
                    attachment="top left"
                    targetAttachment="bottom left"
                    offset="-16px 40px"
                    constraints={[
                        {
                            to: 'window',
                            pin: true,
                        },
                    ]}
                    renderTarget={ref => {
                        return (
                            <div ref={ref}>
                                <AirportDateRangePickerInputs
                                    displayFormat={
                                        DateUtils.getTransientDateDisplayFormat
                                    }
                                    selectedStartDate={selectedStartDate}
                                    selectedEndDate={selectedEndDate}
                                    adjustStartOrEnd={adjustStartOrEnd}
                                    invalidStartDate={invalidStartDate}
                                    invalidEndDate={invalidEndDate}
                                    onStartInputFocus={onStartInputFocus}
                                    onEndInputFocus={onEndInputFocus}
                                />
                            </div>
                        );
                    }}
                    renderElement={ref => {
                        return (
                            showCalendar && (
                                <div ref={ref}>
                                    <div className={arrowClasses} />
                                    <DatePickerCalendarWithRange
                                        className="AirportDateRangePicker-calendar"
                                        onChange={this._onDateChange}
                                        selectedStartDate={selectedStartDate}
                                        selectedEndDate={selectedEndDate}
                                        numberOfMonths={2}
                                        adjustStartOrEnd={adjustStartOrEnd}
                                        weekdayTitles={weekdays}
                                        disableAfter={disableAfterDate}
                                    />
                                </div>
                            )
                        );
                    }}
                />
                <Button
                    className="AirportDateRangePicker-submit"
                    color="primary"
                    onClick={onSubmit}
                >
                    Search
                </Button>
            </div>
        );
    }
}

export default WithAirportDateRangePicker(AirportDateRangePickerDesktop);
